import FormattedMessage from 'I18n/components/FormattedMessage';
import { METRICS_LIMITS } from 'automation-ui-canvas/constants/Gates';
import { WORKFLOWS_CONVERSION_REPORTING } from 'automation-ui-canvas/constants/Scopes';
import EnrollmentConversionToggleInfo from 'automation-ui-canvas/containers/enrollment-conversion/panel/EnrollmentConversionToggleInfo';
import { useHasScope, useIsUngated } from 'automation-ui-core/hooks/authHooks';
import { Flex } from 'foundations-components/components/Flex';
import { FormControl } from 'foundations-components/transitional/components/FormControl';
import { LockBadge } from 'foundations-components/transitional/components/LockBadge';
import { Tile, TileSection } from 'foundations-components/transitional/components/Tile';
import { Toggle } from 'foundations-components/transitional/components/Toggle';
import { Tooltip } from 'foundations-components/transitional/components/Tooltip';
import { useUpgradeModal } from 'ui-addon-upgrades/ums/useUpgradeModal';
import { jsx as _jsx } from "react/jsx-runtime";
import { jsxs as _jsxs } from "react/jsx-runtime";
const EnrollmentConversionToggle = ({
  isReportingEnabled,
  setReportingEnabled,
  limit,
  enabledCount,
  isEnablementRecommended,
  shouldAllowEnablement,
  errorMessage
}) => {
  const isUngatedForMetricsLimits = useIsUngated(METRICS_LIMITS);
  const canViewConversionReporting = useHasScope(WORKFLOWS_CONVERSION_REPORTING);
  const {
    openUpgradeModal
  } = useUpgradeModal('enterprise-conversion-reporting');
  if (!isUngatedForMetricsLimits || isReportingEnabled) {
    return null;
  }
  const handleChange = () => {
    if (!canViewConversionReporting) {
      openUpgradeModal();
      return;
    }
    setReportingEnabled();
  };
  const isToggleEnabled = (shouldAllowEnablement || isReportingEnabled) && !errorMessage;
  return /*#__PURE__*/_jsx(Tile, {
    children: /*#__PURE__*/_jsx(TileSection, {
      padding: "600",
      children: /*#__PURE__*/_jsx(FormControl, {
        label: /*#__PURE__*/_jsx(FormattedMessage, {
          message: "automation.enrollmentConversion.panel.tracking-toggle.header"
        }),
        children: /*#__PURE__*/_jsxs(Flex, {
          flexDirection: "column",
          gap: "400",
          children: [/*#__PURE__*/_jsx("div", {
            children: /*#__PURE__*/_jsx(FormattedMessage, {
              message: "automation.enrollmentConversion.panel.tracking-toggle.body"
            })
          }), /*#__PURE__*/_jsxs(Flex, {
            flexDirection: "row",
            alignItems: "center",
            gap: "300",
            children: [/*#__PURE__*/_jsx(Tooltip, {
              title: /*#__PURE__*/_jsx(FormattedMessage, {
                message: "automation.enrollmentConversion.panel.tracking-toggle.tooltips.disabled"
              }),
              disabled: isToggleEnabled,
              children: /*#__PURE__*/_jsx(FormControl, {
                error: !!errorMessage,
                validationMessage: errorMessage,
                children: /*#__PURE__*/_jsx(Toggle, {
                  checked: isReportingEnabled,
                  onChange: handleChange,
                  disabled: !isToggleEnabled
                })
              })
            }), !canViewConversionReporting && /*#__PURE__*/_jsx(LockBadge, {})]
          }), /*#__PURE__*/_jsx(EnrollmentConversionToggleInfo, {
            enabledCount: enabledCount,
            limit: limit,
            isEnablementRecommended: isEnablementRecommended
          })]
        })
      })
    })
  });
};
export default EnrollmentConversionToggle;